import styled from "styled-components";

type ContainerType = {
    background: string;
    fixHeight: number;
};

type ContainerViewType = {
    background: string;
};

export const Container = styled.div<ContainerType>`
    display: flex;
    flex: 1;
    height: ${props => `calc(100vh - ${props.fixHeight + 61}px)`};
    flex-direction: column;
    overflow: hidden;
    position: relative;
    background: ${(props) => props.background};
`;

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 1;
    overflow: hidden;
`;

export const ContentFormView = styled.div`
    display: flex;
    flex: 1;
    width: 100%;
    flex-direction: column;
    background: transparent;
    position: relative;
    overflow: hidden;
`;

export const ContentView = styled.div<ContainerViewType>`
    display: flex;
    flex: 1;
    overflow: hidden;
    flex-direction: column;
    background: ${props => props.background};
`;
